/**
 * Curated wordlist for OnPass memorable passphrases (PR-25 follow-up).
 *
 * Chosen to be **easy to read, type, and dictate over the phone**: short
 * (3–6 letters), common, all lowercase, no look-alike/ambiguous spellings, no
 * homophones, no profanity. Entropy per word = log2(WORDS.length); the
 * generator surfaces the total so the helpdesk can add words for more strength.
 *
 * This list is intentionally modest in size (keeps the bundle small) — for a
 * one-time, expiring, link-gated OnPass secret the link + expiry are the primary
 * controls, and readability is the goal here.
 */
export const WORDS: readonly string[] = [
  'able', 'acid', 'acorn', 'actor', 'adapt', 'agent', 'album', 'alert', 'alley', 'amber',
  'angle', 'ankle', 'apple', 'apron', 'arena', 'armor', 'arrow', 'aside', 'asset', 'atlas',
  'attic', 'audio', 'autumn', 'award', 'awake', 'badge', 'baker', 'banjo', 'barge', 'basil',
  'basin', 'beach', 'beard', 'beast', 'bench', 'berry', 'bison', 'blade', 'blaze', 'blend',
  'block', 'bloom', 'board', 'bonus', 'boost', 'booth', 'brace', 'brain', 'brave', 'bread',
  'brick', 'bridge', 'broom', 'brush', 'bunch', 'cabin', 'cable', 'cacao', 'camel', 'candy',
  'canoe', 'canyon', 'cargo', 'carol', 'catch', 'cedar', 'chair', 'chalk', 'charm', 'chase',
  'cheer', 'chess', 'chest', 'chief', 'chime', 'churn', 'clamp', 'clean', 'clerk', 'cliff',
  'cloak', 'clock', 'cloud', 'clove', 'clown', 'coach', 'coast', 'cobra', 'cocoa', 'comet',
  'coral', 'couch', 'cover', 'crane', 'crate', 'cream', 'creek', 'crest', 'crisp', 'crown',
  'crumb', 'curve', 'daisy', 'dance', 'delta', 'diary', 'diner', 'ditch', 'dough', 'draft',
  'drama', 'dream', 'dress', 'drift', 'drink', 'drum', 'eagle', 'earth', 'easel', 'ember',
  'envoy', 'epoch', 'equal', 'event', 'fable', 'fairy', 'fancy', 'feast', 'fence', 'ferry',
  'fiber', 'field', 'flame', 'flash', 'fleet', 'flock', 'flour', 'flute', 'foggy', 'forest',
  'fox', 'frame', 'frost', 'fruit', 'fudge', 'gauge', 'ghost', 'giant', 'globe', 'glove',
  'grace', 'grain', 'grape', 'grass', 'green', 'grove', 'guava', 'guide', 'guitar', 'habit',
  'hatch', 'haven', 'hazel', 'heart', 'hedge', 'hippo', 'honey', 'horse', 'hotel', 'house',
  'human', 'humor', 'ivory', 'jelly', 'jewel', 'joker', 'judge', 'juice', 'koala', 'lamp',
  'lance', 'larch', 'layer', 'leaf', 'ledge', 'lemon', 'lever', 'light', 'lilac', 'liner',
  'llama', 'lobby', 'lodge', 'lotus', 'lunar', 'lunch', 'maple', 'march', 'marsh', 'mason',
  'medal', 'melon', 'mercy', 'metal', 'meter', 'mango', 'mint', 'modem', 'money', 'month',
  'moose', 'motor', 'mound', 'mouse', 'mover', 'music', 'nacho', 'navy', 'nest', 'noble',
  'north', 'novel', 'oasis', 'ocean', 'olive', 'onion', 'orbit', 'otter', 'oven', 'owl',
  'paint', 'panda', 'paper', 'park', 'party', 'pasta', 'patch', 'peach', 'pearl', 'pedal',
  'penny', 'perch', 'piano', 'pilot', 'pixel', 'pizza', 'plank', 'plant', 'plaza', 'plum',
  'poem', 'point', 'polar', 'pond', 'pony', 'porch', 'power', 'prawn', 'press', 'pride',
  'prism', 'prize', 'pulse', 'punch', 'puppy', 'quartz', 'queen', 'quest', 'quill', 'quilt',
  'radar', 'raft', 'rain', 'ranch', 'raven', 'reef', 'relay', 'rhino', 'ridge', 'rifle',
  'river', 'roast', 'robin', 'robot', 'rocket', 'rope', 'rose', 'round', 'royal', 'ruby',
  'sable', 'salad', 'sauce', 'scarf', 'scene', 'scout', 'sedan', 'shark', 'sheep', 'shelf',
  'shell', 'shirt', 'shore', 'sketch', 'slate', 'sloth', 'smile', 'snack', 'solar', 'sound',
  'south', 'space', 'spark', 'spice', 'spine', 'spoon', 'sport', 'stage', 'stamp', 'stand',
  'steam', 'steel', 'stork', 'storm', 'study', 'sugar', 'swan', 'sweet', 'swift', 'sword',
  'table', 'tango', 'teach', 'tempo', 'thorn', 'tiger', 'toast', 'token', 'tomato', 'tower',
  'track', 'train', 'treat', 'trend', 'tribe', 'trout', 'trunk', 'tulip', 'tunic', 'turtle',
  'twine', 'ultra', 'umbra', 'unity', 'uplift', 'urban', 'usher', 'valet', 'valley', 'vapor',
  'vault', 'velvet', 'venom', 'vest', 'video', 'villa', 'vine', 'viper', 'vivid', 'vocal',
  'wagon', 'walnut', 'water', 'wheat', 'wheel', 'whale', 'willow', 'wind', 'wolf', 'world',
  'wrist', 'yacht', 'yeast', 'zebra', 'zone',
];
